import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=7cc4e6b8"
import script from "../controllers/Notifications.ts?vue&type=script&lang=js&external"
export * from "../controllers/Notifications.ts?vue&type=script&lang=js&external"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=7cc4e6b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports